// extracted by mini-css-extract-plugin
export default {"collectionHeading":"XQfDc","collectionCount":"PtIT8","toggleVisibleSolutionsListBtn":"RsrGl","solutionsDisplay":"wbbb9"};